export enum EventRequestName {
  eventRequestTransaction = 'eventRequestTransaction',
}

export type EventRequestRequestNameType = keyof typeof EventRequestName;
